var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "dateRangePicker" }, [
    _vm.mode === "quick"
      ? _c("div", { staticClass: "quickRanges" }, [
          _c("div", { staticClass: "quickOptions" }, [
            _vm.isQuickOptionAvailable("last1")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last1" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last1")
                      },
                    },
                  },
                  [_vm._v("Yesterday")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("last7")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last7" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last7")
                      },
                    },
                  },
                  [_vm._v("Last 7 Days")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("last30")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last30" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last30")
                      },
                    },
                  },
                  [_vm._v("Last 30 Days")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("last90")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last90" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last90")
                      },
                    },
                  },
                  [_vm._v("Last 90 Days")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("thisMonth")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: {
                      selected: "thisMonth" === _vm.selectedQuickOption,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("thisMonth")
                      },
                    },
                  },
                  [_vm._v("This Month")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("prevMonth")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: {
                      selected: "prevMonth" === _vm.selectedQuickOption,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("prevMonth")
                      },
                    },
                  },
                  [_vm._v("Previous Month")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("last3m")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last3m" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last3m")
                      },
                    },
                  },
                  [_vm._v("Last 3 Months")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("last12m")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last12m" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last12m")
                      },
                    },
                  },
                  [_vm._v("Last 12 Months")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("weekTD")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "weekTD" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("weekTD")
                      },
                    },
                  },
                  [_vm._v("Week to Date")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("monthTD")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "monthTD" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("monthTD")
                      },
                    },
                  },
                  [_vm._v("Month to Date")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isQuickOptionAvailable("quarterTD")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: {
                      selected: "quarterTD" === _vm.selectedQuickOption,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("quarterTD")
                      },
                    },
                  },
                  [_vm._v("Quarter to Date")]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isGov && _vm.isQuickOptionAvailable("yearTD")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "yearTD" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("yearTD")
                      },
                    },
                  },
                  [_vm._v("Year to Date")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isGov && _vm.isQuickOptionAvailable("ffyTD")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "ffyTD" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("ffyTD")
                      },
                    },
                  },
                  [_vm._v("Federal Fiscal Year to Date")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.internalUser && _vm.isQuickOptionAvailable("last10y")
              ? _c(
                  "div",
                  {
                    staticClass: "quickOption",
                    class: { selected: "last10y" === _vm.selectedQuickOption },
                    on: {
                      click: function ($event) {
                        return _vm.handleQuickRangeClick("last10y")
                      },
                    },
                  },
                  [_vm._v("Last 10 Years")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function ($event) {
                  return _vm.goToCustomMode()
                },
              },
            },
            [_vm._v("Custom Range")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.mode === "custom"
      ? _c(
          "div",
          { staticClass: "customRange" },
          [
            _c("vc-date-picker", {
              attrs: {
                "is-range": "",
                color: "purple",
                columns: _vm.$screens({ default: 1, md: 2 }),
                rows: _vm.$screens({ default: 1, md: 2 }),
                "is-expanded": _vm.$screens({ default: true, md: false }),
                "min-date": _vm.minDate,
                "max-date": _vm.maxDate,
              },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "customRangeFooter" }, [
              _c(
                "span",
                {
                  staticClass: "backToQuickLink",
                  on: {
                    click: function ($event) {
                      return _vm.goToQuickMode()
                    },
                  },
                },
                [_vm._v("View other date ranges")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary apply",
                  on: {
                    click: function ($event) {
                      return _vm.rangeSelected(
                        _vm.dateRange.start,
                        _vm.dateRange.end
                      )
                    },
                  },
                },
                [_vm._v("Apply")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }